// extracted by mini-css-extract-plugin
export default {"main":"DurationInput--main--sRIPD","helpIcon":"DurationInput--helpIcon--Ij98F","warnIcon":"DurationInput--warnIcon--L+1If"};